export default __webpack_public_path__ + "static/media/IconNotificacaoHeader.a94c532c.svg";